import React from 'react'
import { Select } from 'antd'
import { useFetchConceptualLabelTypesQuery } from '../../../../store/apis/conceptual-label-type.api'
import { renderOptionWithDescription } from '../../../../utils/antd.helper'

const ConceptualLabelSelectType = ({ value, onChange }) => {
    const { data: types, isFetching } = useFetchConceptualLabelTypesQuery()

    const options = types?.map(type => ({
        label: type.name,
        value: type.id,
        description: type.description,
        title: `${type.name} - ${type.description}`,
    }))

    return (
        <Select
            placeholder="Select a label type"
            value={value}
            onChange={onChange}
            loading={isFetching}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            options={options}
            optionRender={renderOptionWithDescription}
        >
        </Select>
    )
}

export default ConceptualLabelSelectType 